import React, { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext();

const typeConfig = {
  success: { icon: "fa-check-circle",        color: "#10b981" },
  error:   { icon: "fa-times-circle",         color: "#ef4444" },
  warning: { icon: "fa-exclamation-triangle", color: "#f59e0b" },
  info:    { icon: "fa-info-circle",           color: "#3b82f6" },
};

const ToastItem = ({ toast, onRemove }) => {
  const cfg = typeConfig[toast.type] || typeConfig.info;
  return (
    <div className="ims-toast-item" style={{ borderLeftColor: cfg.color }}>
      <i className={`fas ${cfg.icon} ims-toast-icon`} style={{ color: cfg.color }} />
      <div className="ims-toast-body">
        <div className="ims-toast-title">{toast.title}</div>
        {toast.message && <div className="ims-toast-msg">{toast.message}</div>}
      </div>
      <button className="ims-toast-close" onClick={() => onRemove(toast.id)}>×</button>
    </div>
  );
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((type, title, message = "") => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, type, title, message }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3500);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toasts.length > 0 && (
        <div className="ims-toast-container">
          {toasts.map(t => (
            <ToastItem key={t.id} toast={t} onRemove={removeToast} />
          ))}
        </div>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
export default ToastContext;
